
import { getUser, getCollege, getHistorySearch } from '../common/js/cache'

const state = {
	user: getUser(),
	// user: {
	// 	id: 2,
	// 	showname: '你的名字',
	// 	nickname:'ni陈'
	// },
	history_search: getHistorySearch(),
	college:{id: 0} //getCollege()
}

export default state


// WEBPACK FOOTER //
// ./src/store/state.js